import {getAllNodesInSub} from './findNode.js';

export default superclass => class extends superclass {
    loadLostParameters(isSubSequence) {
        for (let effect of this.midiEffects.effects) {
            let effects = effect.effects || [effect];
            effects.filter(
                x => x.lostParameters && x.lostParameters.length > 0)
                .forEach(x => {
                    x.lostParameters = x.loadParameters(x.lostParameters);
                });
        }

        if (this.tracks) {
            this.tracks.forEach(
                (t) => isSubSequence ? t.loadLostParameters() :
                    t.track ? t.track.loadLostParameters() : 0);
        }

        if (isSubSequence) {
            let nodes = getAllNodesInSub(this);
            nodes.filter(
                t => t.effect && t.effect.lostParameters && t.effect.lostParameters.length > 0)
                .forEach(
                    x => x.effect.lostParameters = x.effect.loadParameters(x.effect.lostParameters));
        }
    }
}
